<template>
  <v-toolbar dense color="grey lighten-3" fixed style="z-index: 7">
    <filter-drawer-toggle />
    <filter-result-counter v-show="$vuetify.breakpoint.smAndUp" />
    <v-spacer />
    <external-stations-toggle v-show="$vuetify.breakpoint.mdAndUp" />
    <the-view-toggler />
    <v-tooltip :open-delay="500" bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          :color="exportButtonFocused ? null : 'primary'"
          style="height: 34px;"
          depressed
          class="ml-3"
          @blur="exportButtonFocused = false"
          @focus="exportButtonFocused = true"
          @click="showExportDialog = true"
        >
          Eksporter data
        </v-btn>
      </template>
      <span>Eksporter et utvalg av tidsserier</span>
    </v-tooltip>
    <export-data
      :show="showExportDialog"
      @dialog-closed="showExportDialog = false"
    />
  </v-toolbar>
</template>

<script>
import { FilterResultCounter, TheViewToggler } from "@/components";
import FilterDrawerToggle from "./FilterDrawerToggle.vue";
import ExternalStationsToggle from "./ExternalStationsToggle.vue";
import ExportData from "../Table/ExportData.vue";
export default {
  name: "TheContentToolbar",
  data: () => {
    return {
      showExportDialog: false,
      exportButtonFocused: false,
    };
  },
  components: {
    FilterResultCounter,
    TheViewToggler,
    FilterDrawerToggle,
    ExternalStationsToggle,
    ExportData,
  },
};
</script>

<style></style>
